module.exports = __webpack_public_path__ + "static/media/privacy-policy-banner.a4dda5bf.jpg";